import { defineMessages } from 'react-intl';

/**
 * Will have the messages displayed in ManageMincTransactions component
 */
const messages = defineMessages({
  title: {
    id: 'App.ManageMincTransactions.Title',
    defaultMessage: 'Manage MINC Transactions',
  },
  generateReport: {
    id: 'App.ManageMincTransactions.GenerateReport',
    defaultMessage: 'Generate Report',
  },
  chooseDates: {
    id: 'App.ManageMincTransactions.ChooseDates',
    defaultMessage: 'Choose Dates',
  },
  // Table Headers
  headOfHousehold: {
    id: 'App.ManageMincTransactions.HeadOfHousehold',
    defaultMessage: 'Head of Household',
  },
  unitNumber: {
    id: 'App.ManageMincTransactions.UnitNumber',
    defaultMessage: 'Unit',
  },
  certificationType: {
    id: 'App.ManageMincTransactions.CertificationType',
    defaultMessage: 'Cert Type',
  },
  effectiveDate: {
    id: 'App.ManageMincTransactions.EffectiveDate',
    defaultMessage: 'Effective Date',
  },
  certificationCompletionDate: {
    id: 'App.ManageMincTransactions.CertificationCompletionDate',
    defaultMessage: 'Cert Completion Date',
  },
  status: {
    id: 'App.ManageMincTransactions.Status',
    defaultMessage: 'Status',
  },
  // Messages to use later on for modals
  modalTitle: {
    id: 'App.ManageMincTransactions.modalTitle',
    defaultMessage: 'Modal Title',
  },
  testField: {
    id: 'App.ManageMincTransactions.TestField',
    defaultMessage: 'Test Field',
  },
  mustSelectOneRow: {
    id: 'App.ManageMincTransactions.mustSelectOneRow',
    defaultMessage: 'There are no certifications selected.',
  },
  configureProjectPaymentButton: {
    id: 'App.ManageMincTransactions.ConfigureProjectPaymentButton',
    defaultMessage: 'Configure Project Payment',
  },
  configureProjectPaymentModalTitle: {
    id: 'App.ManageMincTransactions.ConfigureProjectPaymentModalTitle',
    defaultMessage: 'Monthly Project Payment',
  },
  amountDue: {
    id: 'App.ManageMincTransactions.AmountDue',
    defaultMessage: 'Amount Due',
  },
  monthlyMortgageFormHeader: {
    id: 'App.ManageMincTransactions.MonthlyMortgageFormHeader',
    defaultMessage:
      'This is the monthly mortgage payment due to Rural Development',
  },
  generateProjectWorksheetModalTitle: {
    id: 'App.ManageMincTransactions.GenerateProjectWorksheetModalTitle',
    defaultMessage: 'Generate Project Worksheet',
  },
  amountValidationMessage: {
    id: 'App.ManageMincTransactions.AmountValidationMessage',
    defaultMessage: 'Amount must be 0 or greater',
  },
});

export default messages;
